<ng-container *ngIf="!!(selectIsLoggedIn$ | async) else loggedOut">
	@defer (when (selectIsLoggedIn$ | async)) {
		<bdc-secure-layout></bdc-secure-layout>
	} @placeholder {
		<loading-indicator></loading-indicator>
	}
</ng-container>
<ng-template #loggedOut>
	<app-public-layout></app-public-layout>	
</ng-template>
<!-- <h1>Root Layout</h1> -->